export enum DrawerView {
  CLOSED = 'CLOSED',
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
}
